import { render, staticRenderFns } from "./CustomFeedback.vue?vue&type=template&id=247b86ec&scoped=true&"
import script from "./CustomFeedback.vue?vue&type=script&lang=js&"
export * from "./CustomFeedback.vue?vue&type=script&lang=js&"
import style0 from "./CustomFeedback.vue?vue&type=style&index=0&id=247b86ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b86ec",
  null
  
)

export default component.exports